import urlUtils from '@/utils/urlUtils';

const getContentPath = (relative: string) => {
    if (!relative) return;

    if (relative.startsWith('http')) return relative;

    if (import.meta.env.VITE_ENV === 'local') {
        return urlUtils.join('https://tips.icpwa-dev.aws.pmicloud.biz/assets', relative);
    }

    const contentPath = '/assets';

    return urlUtils.join(contentPath, relative);
};

export default {
    getContentPath,
};
